// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1678) return "static/chunks/mui-5377510d0ab9aff3.js";
	if (chunkId === 3454) return "static/chunks/3454-0dfabfd4fa1328d7.js";
	if (chunkId === 8367) return "static/chunks/8367-226db125aba5c136.js";
	if (chunkId === 8188) return "static/chunks/8188-9265fe020c33e3c3.js";
	if (chunkId === 718) return "static/chunks/718-0ea4406f098760d8.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","343":"6edf0643","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"22820b16f3f1c6e9","343":"aba59e1018d5505c","5029":"c5337359b7730e26","6713":"0833a31029109f67","8703":"26756ff9763bc32a","9777":"30297d365d455140"}[chunkId] + ".js";
};